import type { RequestListener } from "node:http";
import { FileSystemStore } from "./fs-store";
import { createRequestHandler } from "./handler";
import { serve } from "./serve";
import type { PFrameInternal } from "@milaboratories/pl-model-middle-layer";

export const HttpHelpers: PFrameInternal.HttpHelpers = {
  createFsStore: async (
    options: PFrameInternal.FsStoreOptions,
  ): Promise<PFrameInternal.ObjectStore> => {
    return await FileSystemStore.init(options);
  },
  createRequestHandler: (options: PFrameInternal.RequestHandlerOptions): RequestListener => {
    return createRequestHandler(options);
  },
  createHttpServer: async (
    options: PFrameInternal.HttpServerOptions,
  ): Promise<PFrameInternal.HttpServer> => {
    return await serve(options);
  },
};
